<template>
  <v-layout
    class="insights-overview"
    column
    justify-space-between
    fluid
    fill-height
    d-inline-flex
  >
    <page-title title="Overview"></page-title>
    <Filters @change="getData"></Filters>
    <v-flex style="text-align: center"
      ><v-progress-circular indeterminate="" v-if="insightsLoading">
      </v-progress-circular
    ></v-flex>

    <v-flex v-if="!insightsLoading" class="metrics-overview-items" fluid>
      <v-layout row wrap justify-center>
        <v-flex
          xs12 sm5 md5 lg3 xl3
          class="metrics-overview-item mx-3 my-3"
          v-for="metric in metrics"
          :key="metric.header"
          @click.prevent="goToMetric(metric)"
        >
          <div class="metrics-overview-header">
            {{ metric.header }}
          </div>
          <div class="metrics-overview-sub-header">{{ metric.subHeader }}</div>
          <div class="metric-insight" :class="metric.class">
            <v-btn
              :to="{ name: routes.SURVEY_METRICS }"
              v-if="metric.disabled"
              depressed
              color="primary"
              @click.stop=""
              >Add</v-btn
            >
            <div v-if="!metric.disabled" class="metric-score">
              <span v-if="metric.insights.score !== 'NO_RESULT'">{{
                metric.insights.score
              }}</span>
              <v-icon
                class="no-result"
                color="#fff"
                v-if="metric.insights.score === 'NO_RESULT'"
                >remove</v-icon
              >
            </div>
            <div v-if="!metric.disabled" class="metric-change mt-5">
              <v-layout
                class="p0 metric-change-top"
                align-center
                justify-center
              >
                <v-icon>
                  {{ metric.changeIcon }}
                </v-icon>
                <div class="metric-change-value">
                  {{
                    metric.insights.change_over_period
                      ? metric.insights.change_over_period + '%'
                      : ''
                  }}
                </div>
              </v-layout>
              <div v-if="!metric.disabled" class="metric-change-label">
                Changeover period
              </div>
            </div>
          </div>

          <div v-if="!metric.disabled" class="metric-overview-footer mt-3">
            {{ metric.footer }}
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-if="!insightsLoading" column class="overview-footer">
      <v-layout
        align-center
        justify-center
        row
        fill-height
        @click="goToMetric({header: 'RESPONSE'})"
      >
        <v-flex xs3
          ><div class="overview-footer-value">{{ insights.count }}</div>
          <div class="overview-footer-label">Total responses</div></v-flex
        >
        <v-flex xs3
          ><div class="overview-footer-value">
            {{ insights.response_rate }}%
          </div>
          <div class="overview-footer-label">Response Rate</div></v-flex
        >
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import routes from '@/route_names'
import insightsApi from '@/api/insights'
import { getDefaultInterval } from '@/helpers/filter'
import Filters from '@/components/insights/Filters'
import filterMixins from '@/mixins/filter'
export default {
  name: 'Overview',
  mixins:[filterMixins],
  components: {
    Filters
  },
  created: function() {
    this.getData()
  },
  data: function() {
    return {
      routes: routes,
      insightsLoading: true,
      insights: null
    }
  },
  computed: {
    metrics: function() {
      const items = []
      const enabledMetrics = this.$store.getters['campaign/enabledMetrics']
      const nps = {}
      nps.header = 'NPS'
      nps.subHeader = 'Net Promoter Score'
      nps.footer = 'NPS score varies from -100 to 100'
      nps.insights = null
      if (enabledMetrics.indexOf('NPS') > -1) {
        nps.disabled = false
        if (this.insights) {
          nps.insights = this.insights.metrics.find(f => f.type === 'NPS')
          if (nps.insights.change_over_period === null) {
            nps.changeIcon = 'remove'
            nps.class = 'score-neutral'
            if (nps.insights.score < 50) {
              nps.class = 'score-down'
            } else if (nps.insights.score > 50) {
              nps.class = 'score-up'
            }
          } else {
            if (nps.insights.change_over_period < 0) {
              nps.changeIcon = 'call_received'
              nps.class = 'score-down'
            } else if (nps.insights.change_over_period > 0) {
              nps.changeIcon = 'call_made'
              nps.class = 'score-up'
            } else if (nps.insights.change_over_period === 'NO_RESULT') {
              nps.insights.change_over_period = null
              nps.changeIcon = 'remove'
              if (nps.insights.score < 50) {
                nps.class = 'score-down'
              } else if (nps.insights.score > 50) {
                nps.class = 'score-up'
              }
            } else {
              nps.changeIcon = 'remove'
              nps.class = 'score-neutral'
              if (nps.insights.score < 50) {
                nps.class = 'score-down'
              } else if (nps.insights.score > 50) {
                nps.class = 'score-up'
              }
            }
          }
        }
      } else {
        nps.disabled = true
      }
      const csat = {}
      csat.header = 'CSAT'
      csat.subHeader = 'Customer Satisfaction Score'
      csat.footer = ' CSAT score varies from 0 to 100'
      csat.insights = null
      if (enabledMetrics.indexOf('CSAT') > -1) {
        csat.disabled = false
        if (this.insights) {
          csat.insights = this.insights.metrics.find(f => f.type === 'SAT')
          if (csat.insights.change_over_period === null) {
            csat.changeIcon = 'remove'
            csat.class = 'score-neutral'
            if (csat.insights.score < 50) {
              csat.class = 'score-down'
            } else if (csat.insights.score > 50) {
              csat.class = 'score-up'
            }
          } else {
            if (csat.insights.change_over_period < 0) {
              csat.changeIcon = 'call_received'
              csat.class = 'score-down'
            } else if (csat.insights.change_over_period > 0) {
              csat.changeIcon = 'call_made'
              csat.class = 'score-up'
            } else if (csat.insights.change_over_period === 'NO_RESULT') {
              csat.insights.change_over_period = null
              if (csat.insights.score < 50) {
                csat.class = 'score-down'
              } else if (csat.insights.score > 50) {
                csat.class = 'score-up'
              }
              csat.changeIcon = 'remove'
            } else {
              csat.changeIcon = 'remove'
              csat.class = 'score-neutral'
              if (csat.insights.score < 50) {
                csat.class = 'score-down'
              } else if (csat.insights.score > 50) {
                csat.class = 'score-up'
              }
            }
          }
        }
      } else {
        csat.disabled = true
      }
      const ces = {}
      ces.header = 'CES'
      ces.subHeader = 'Customer Effort Score'
      ces.footer = 'CES score varies from 0 to 100'
      ces.insights = null
      if (enabledMetrics.indexOf('CES') > -1) {
        ces.disabled = false
        if (this.insights) {
          ces.insights = this.insights.metrics.find(f => f.type === 'ES')
          if (ces.insights.change_over_period === null) {
            ces.changeIcon = 'remove'
            ces.class = 'score-neutral'
            if (ces.insights.score < 50) {
              ces.class = 'score-down'
            } else if (ces.insights.score > 50) {
              ces.class = 'score-up'
            }
          } else {
            if (ces.insights.change_over_period < 0) {
              ces.changeIcon = 'call_received'
              ces.class = 'score-down'
            } else if (ces.insights.change_over_period > 0) {
              ces.changeIcon = 'call_made'
              ces.class = 'score-up'
            } else if (ces.insights.change_over_period === 'NO_RESULT') {
              ces.insights.change_over_period = null
              if (ces.insights.score < 50) {
                ces.class = 'score-down'
              } else if (ces.insights.score > 50) {
                ces.class = 'score-up'
              }
              ces.changeIcon = 'remove'
            } else {
              ces.changeIcon = 'remove'
              ces.class = 'score-neutral'
              if (ces.insights.score < 50) {
                ces.class = 'score-down'
              } else if (ces.insights.score > 50) {
                ces.class = 'score-up'
              }
            }
          }
        }
      } else {
        ces.disabled = true
      }
      items.push(nps)
      items.push(csat)
      items.push(ces)
      return items
    }
  },
  methods: {
    getData: function() {
      const vm = this
      this.insightsLoading = true
      insightsApi
        .getOverview({
          campaignId: this.$router.currentRoute.params.campaignId,
          query: {from: this.$router.currentRoute.query.from,
          to: this.$router.currentRoute.query.to,
          ...this.getAttributeFilters()}
          
        })
        .then(function(res) {
          vm.insights = res.data.results
          vm.insightsLoading = false
        })
        .catch(function(err) {
          vm.insightsLoading = false
          vm.insights = {}
        })
    },
    goToMetric(metric) {
      if(metric.disabled){
        return
      }
      if (metric.header === 'NPS')
        this.$router.push({ name: routes.INSIGHTS_METRICS_NPS })
      else if (metric.header === 'CSAT')
        this.$router.push({ name: routes.INSIGHTS_METRICS_CSAT })
      else if (metric.header === 'CES')
        this.$router.push({ name: routes.INSIGHTS_METRICS_CES })
      else if (metric.header === 'RESPONSE')
        this.$router.push({ name: routes.INSIGHTS_RESPONSES })
    }
  }
}
</script>

<style lang="stylus">
.insights-overview {
    padding-top 0
    width 100%
    .filter-area {
        margin-bottom 10px
        text-align right
    }
    .metrics-overview-item {
        text-align center
        
        min-height 200px
        cursor pointer
        &:last-child {
            margin-right 0
        }
        .metrics-overview-header {
            font-weight 600
            font-size 24px
        }
        .metrics-overview-sub-header {
            font-size 16px
            margin-bottom 20px
        }

    }
    .metric-insight {
        background: #FFFFFF;
        border: 1px solid #F1F2F6;
        box-sizing: border-box;
        box-shadow: 0px 4px 25px rgba(165, 172, 181, 0.25);
        border-radius: 5px;
        display flex
        align-items center
        justify-content center
        flex-direction column
        padding 30px
        .metric-score {
            width 80%
            height 120px
            border-radius: 5px
            display flex
            color: #fff
            align-items center
            justify-content center
            font-size 64px
            font-weight 500
            .no-result {
                font-size 24px
            }
        }

        &.score-down {
            .metric-score {
                background-color $color-error
            }
            .metric-change {
                .v-icon {
                    color $color-error
                }
            }
        }

        &.score-up {
            .metric-score {
                background-color $color-accent
            }
            .metric-change {
                .v-icon {
                    color $color-accent
                }
            }
        }

        &.score-neutral {
            .metric-score {
                background-color $color-primary-light-4
            }
        }

        .metric-change {
            height 70px
            margin-bottom 35px
            .v-icon {
                font-size 26px
            }
        }

        .metric-change-top {
            height 40px
        }

        .metric-change-value{
            font-size 30px
            color $color-primary
            margin-left 5px
        }
        .metric-change-label {
            color $color-primary-light-5
            font-size 16px

        }

    }
    .metric-overview-footer {
            color $color-primary-light-5
        }
    .overview-footer {
        text-align center
        cursor pointer
        .overview-footer-value {
            font-size 36px
            color: $color-primary
        }
        .overview-footer-label {
            font-size 18px
            color: $color-primary-light-5
        }
    }
}
</style>
